/**
 * @file: 右键菜单显示与隐藏
 * @author: xiaolong.huang@dmall.com
 */

function show(params: ShowMenuParams): void {
    $('.shelvesbuild-w-contextmenus').css({
        display: 'block',
        left: `${params.left}px`,
        top: `${params.top}px`
    });
}

function hide(): void {
    $('.shelvesbuild-w-contextmenus').css('display', 'none');
}

export {
    show,
    hide
};
